import { render, staticRenderFns } from "./VoucherList.vue?vue&type=template&id=25239455&scoped=true"
import script from "./VoucherList.vue?vue&type=script&lang=js"
export * from "./VoucherList.vue?vue&type=script&lang=js"
import style0 from "./VoucherList.vue?vue&type=style&index=0&id=25239455&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25239455",
  null
  
)

export default component.exports